import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { Product } from "@/types/products";

export interface CartItem {
	product: Product;
	quantity: number;
}

interface CartState {
	items: CartItem[];
	resetCart: () => void;
	getTotalPrice: (items: CartItem[]) => number;
	getTotalItems: (items: CartItem[]) => number;
	removeItem: (id: string) => void;
	manageItems: (product: Product, action: "add" | "reduce") => void;
}

export const useContractCartStore = create<CartState>()(
	persist(
		set => ({
			items: [],
			getTotalPrice: items =>
				Number(
					items
						.reduce((acc, item) => acc + Number(item.product.price) * item.quantity, 0)
						.toFixed(2)
				),
			getTotalItems: items =>
				items.reduce((acc, item) => acc + item.quantity, 0),
			removeItem: (id: string) =>
				set(state => ({
					items: state.items.filter(item => item.product.id !== id)
				})),
			manageItems: (product: Product, action: "add" | "reduce") =>
				set((state) => {
					const existingItem = state.items.find(
						item => item.product.id === product.id
					);
					if (existingItem) {
						if (action === "reduce" && existingItem.quantity === 1) {
							return {
								items: state.items.filter(item => item.product.id !== product.id)
							};
						}
						return {
							items: state.items.map(item =>
								item.product.id === product.id
									? {
											...item,
											quantity:
												action === "add" ? item.quantity + 1 : item.quantity - 1
										}
									: item
							)
						};
					}
					else {
						return {
							items: [...state.items, { product, quantity: 1 }]
						};
					}
				}),
			resetCart: () => set({ items: [] })
		}),
		{
			name: "intasida/contract-cart"
		}
	)
);
